import cx from 'classnames';
import Image, { ImageProps } from 'next/image';

import { LocalHeroMark } from '../local-hero/LocalHeroMark';
import { RATIO, Ratio } from '../ratio/Ratio';

import style from './ProfilePicture.module.css';

export type ProfilePictureProps = {
    image: ImageProps & {
        alt: NonNullable<ImageProps['alt']>;
        sizes: NonNullable<ImageProps['sizes']>;
    };
} & (
    | {
          isLocalHero: true;
          isOnline?: never;
      }
    | {
          isLocalHero?: false;
          isOnline?: boolean;
      }
);

export function ProfilePicture({ image, isLocalHero = false, isOnline }: ProfilePictureProps) {
    return (
        <Ratio ratio={ProfilePicture.PICTURE_RATIO}>
            <Image {...image} alt={image.alt} className={cx(style.image, image.className)} fill />
            {isLocalHero ? (
                <LocalHeroMark
                    className={style.localHeroMark}
                    data-testid="ProfilePictureLocalHeroMark"
                />
            ) : null}
            {isOnline !== undefined ? (
                <div
                    className={cx(style.status, {
                        [style.online]: isOnline,
                        [style.offline]: !isOnline,
                    })}
                />
            ) : null}
        </Ratio>
    );
}

ProfilePicture.PICTURE_RATIO = RATIO['1/1'];
